import { render, staticRenderFns } from "./_NotifContentNew.vue?vue&type=template&id=3eec823d&scoped=true&"
import script from "./_NotifContentNew.vue?vue&type=script&lang=js&"
export * from "./_NotifContentNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eec823d",
  null
  
)

export default component.exports